export default {
  namespaced: true,
  state: {
    notice: {},
  },
  getters: {
    notice: state => state.notice,
  },
  actions: {
    resetCurrent: (context) => {
      context.commit('resetCurrent');
    },
    setNotice: (context, notice) => {
      context.commit("setNotice", notice);
    } 
  },
  mutations: {
    resetCurrent: (state) => {
      state.notice = {};
    },
    setNotice: (state, notice) => {
      state.notice = { ...notice }; //make a "deep" copy

      if (state.notice.parcelType === 'Bulky') {
        // bulky parcels only allow 1 barcode
        // in case user switched between notice types, clear all other tracking numbers
        // if the user switches back to a notice type allowing multiple tracking numbers any previously entered numbers will still be visible
        state.notice.trackingNumber2 = null;
        state.notice.trackingNumber3 = null;
    }

    }
  }
}
